import React from "react";
import { Link, useSearchParams } from "react-router-dom";

const PaymentCancelled = () => {
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get("order_number");

  return (
    <div>
      <nav className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <Link className="navbar-brand" to="/">
              By The App
            </Link>
          </div>
        </div>
      </nav>

      <main className="payment-result-page">
        <div className="container">
          <div className="payment-result-card payment-result-cancelled">
            <div className="payment-result-icon payment-result-icon-cancelled" aria-hidden="true">
              ×
            </div>
            <h1>Payment Cancelled</h1>
            <p>
              Your payment was not completed. No charges were made to your account.
            </p>
            {orderNumber && (
              <p className="payment-result-order">
                Order reference: <strong>{orderNumber}</strong>
              </p>
            )}
            <p className="payment-result-note">
              To complete your order, use the payment link sent to your phone or call the
              business again. If you need help, contact{" "}
              <a href="mailto:info@bytheapp.com">info@bytheapp.com</a>.
            </p>
            <Link to="/" className="btn btn-custom btn-lg">
              Back to Home
            </Link>
          </div>
        </div>
      </main>

      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2026 ByTheApp. All rights reserved.{" "}
            <a href="mailto:info@bytheapp.com">info@bytheapp.com</a>
            {" · "}
            <Link to="/privacy">Privacy Policy</Link>
            {" · "}
            <Link to="/terms">Terms</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
